type HistoryEntry = {
  title?: string;
  description?: string;
  refType?: string;
  earnedByMemberId?: string;
  incomeBuyerId?: string;
  fromMemberId?: string;
  toMemberId?: string;
  orderCode?: string;
};

const HistoryDetails = ({ row }: { row: HistoryEntry }) => {
  const title = row.title || row.refType || "Transaction";
  const description = row.description || "";
  const visibleCopy = `${title} ${description}`.toUpperCase();
  const buyerId = (row.incomeBuyerId || "").trim().toUpperCase();
  const toId = (row.toMemberId || "").trim().toUpperCase();
  const candidates = [
    { label: "Earned by", value: row.earnedByMemberId },
    { label: "Buyer", value: row.incomeBuyerId },
    { label: "From", value: row.fromMemberId },
    // With buyer routing, toMemberId can be the allocated placement member,
    // while incomeBuyerId identifies the wallet that actually received it.
    {
      label: buyerId && toId !== buyerId ? "Allocated to" : "To",
      value: row.toMemberId,
    },
  ];
  const seen = new Set<string>();
  const details = candidates.flatMap(({ label, value }) => {
    const id = (value || "").trim().toUpperCase();
    if (!id || visibleCopy.includes(id) || seen.has(id)) return [];
    seen.add(id);
    return [`${label}: ${id}`];
  });
  const orderCode = (row.orderCode || "").trim();
  if (orderCode && !visibleCopy.includes(orderCode.toUpperCase())) {
    details.push(`Order: ${orderCode}`);
  }

  return (
    <>
      <div>{title}</div>
      {description && <div className="table-muted">{description}</div>}
      {details.length > 0 && (
        <div className="table-muted">{details.join(" · ")}</div>
      )}
    </>
  );
};

export default HistoryDetails;
